import { PAYMENT_TYPES } from 'constants/enums'

export const getPaymentTypeId = key =>
  ({
    directPaymentEnabled: PAYMENT_TYPES.offline.id,
    exemptFromPaymentEnabled: PAYMENT_TYPES.exempt.id,
    onlineMastercardPaymentEnabled: PAYMENT_TYPES.online.id,
    onlineManualPaymentEnabled: PAYMENT_TYPES.onlineManual.id,
    onlineGPPaymentEnabled: PAYMENT_TYPES.globalPayments.id,
    onlineGPWebpayPaymentEnabled: PAYMENT_TYPES.globalPaymentsWebpay.id
  }[key])
